module.exports = __webpack_public_path__ + "3cf36f09bd65ef82e9a608b28e6c939d.png";